export default "__VITE_ASSET__g$4_zwVA__"